import React from 'react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { AccountInfoLabel } from '@woovi/ui';

import type { PaymentLinkCompletedTransaction_charge$key } from './__generated__/PaymentLinkCompletedTransaction_charge.graphql.ts';

type PaymentLinkCompletedTransactionProps = {
  charge: PaymentLinkCompletedTransaction_charge$key;
};
const PaymentLinkCompletedTransaction = (
  props: PaymentLinkCompletedTransactionProps,
): ReactNode => {
  const { t } = useTranslation();
  const charge = useFragment<PaymentLinkCompletedTransaction_charge$key>(
    graphql`
      fragment PaymentLinkCompletedTransaction_charge on Charge {
        transactions: pixTransactions {
          edges {
            node {
              endToEndId
            }
          }
        }
      }
    `,
    props.charge,
  );

  if (
    !charge?.transactions ||
    !charge.transactions.edges.length ||
    !charge.transactions.edges[0]?.node?.endToEndId
  ) {
    return null;
  }

  return (
    <AccountInfoLabel
      label={t('Transaction ID')}
      text={charge?.transactions.edges[0]?.node?.endToEndId}
    />
  );
};

export default PaymentLinkCompletedTransaction;
